<template>
  <form id="frm_action">
  <div class="p-formgrid">
        <div class="p-card-field p-0">
          <div class="text-box">
            <div class="p-card-field p-0" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
              <label class="txt-right">Công ty</label>
              <DropdownScrollable cusClass="m-0" :loading="loading" width="100%" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="items" :total="total" @keyup="emitEvent" @offset="changeOffset" :disabled="(mode=='edit') ? true : false"/>
              <input class="input_tmp_validator" id="company" />
            </div>
            <div class="p-card-field p-0 mt-3">
              <label class="txt-right required">Tên nhóm quyền</label>
              <div class="">
                <Textarea :autoResize="true"  rows="1" maxlength="255" v-model="name"  id="name" type="text" placeholder="Nhập " />
              </div>
            </div>
            <input class="input_tmp_validator" id="role" />
          </div>
          <label class="">Module</label>
            <div class="tab">
                <div :class="{ active: currentTab == 0 , 'hide-tab' : hideTab == 0}" @click="showContent(0)">Hệ thống</div>
                <div :class="{ active: currentTab == 1 , 'hide-tab' : hideTab1 == 0}" @click="showContent(1)">Quản lý nhà thầu</div>
                <div :class="{ active: currentTab == 2 , 'hide-tab' : hideTab2 == 0}" @click="showContent(2)">Quản lý rủi ro</div>
                <div :class="{ active: currentTab == 3 , 'hide-tab' : hideTab3 == 0}" @click="showContent(3)">Chức năng khác</div>
                <div :class="{ active: currentTab == 4 , 'hide-tab' : hideTab4 == 0}" @click="showContent(4)">Khác</div>
            </div>
            <div :class="{ content : true, active: currentTab == 0 }">
              <div class="position-relative">
                <div v-for="(item_c, index_c) in list_controller" :key="index_c">
                  <div class="p-field p-grid box-permission" v-if="item_c.list_modle_key.includes('system')">
                    <div class="p-col-6 box-left permission-left">
                      <div class="box span-label">{{ item_c.name }}</div>
                    </div>
                    <div class="p-col-6 box-right permission-right">
                      <!-- cho 1 cấp -->
                      <div v-if="item_c.is_parent == 0" class="row custom-lable div-checkbox">
                        <div v-for="(roles_for, index_roles_for) in item_c.roles" :key="index_roles_for" class="d-flex col-12 align-items-center ml-3 mb-3 p-0">
                          <Checkbox :id="`checkbox-id-${roles_for.id}`" class="mr-2" v-model="checked[roles_for.id]" :binary="true"/>
                          <label :for="`checkbox-id-${roles_for.id}`" class="txt-right mb-0">{{roles_for.name}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div :class="{ content : true, active: currentTab == 1 }">
              <div class="position-relative">
                <div v-for="(item_c, index_c) in list_controller" :key="index_c">
                  <div class="p-field p-grid box-permission" v-if="item_c.list_modle_key.includes('contractors_management')">
                    <div class="p-col-6 box-left permission-left">
                      <div class="box span-label">{{ item_c.name }}</div>
                    </div>
                    <div class="p-col-6 box-right permission-right">
                      <!-- cho 1 cấp -->
                      <div v-if="item_c.is_parent == 0" class="row custom-lable div-checkbox">
                        <div v-for="(roles_for, index_roles_for) in item_c.roles" :key="index_roles_for" class="d-flex col-12 align-items-center ml-3 mb-3 p-0">
                          <Checkbox :id="`checkbox-id-${roles_for.id}`" class="mr-2" v-model="checked[roles_for.id]" :binary="true"/>
                          <label :for="`checkbox-id-${roles_for.id}`" class="txt-right mb-0">{{roles_for.name}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div :class="{ content : true, active: currentTab == 2 }">
              <div class="position-relative">
                <div v-for="(item_c, index_c) in list_controller" :key="index_c">
                  <div class="p-field p-grid box-permission" v-if="item_c.list_modle_key.includes('risk_management')">
                    <div class="p-col-6 box-left permission-left">
                      <div class="box span-label">{{ item_c.name }}</div>
                    </div>
                    <div class="p-col-6 box-right permission-right">
                      <!-- cho 1 cấp -->
                      <div v-if="item_c.is_parent == 0" class="row custom-lable div-checkbox">
                        <div v-for="(roles_for, index_roles_for) in item_c.roles" :key="index_roles_for" class="d-flex col-12 align-items-center ml-3 mb-3 p-0">
                          <Checkbox :id="`checkbox-id-${roles_for.id}`" class="mr-2" v-model="checked[roles_for.id]" :binary="true"/>
                          <label :for="`checkbox-id-${roles_for.id}`" class="txt-right mb-0">{{roles_for.name}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div :class="{ content : true, active: currentTab == 3 }">
              <div class="position-relative">
                <div v-for="(item_c, index_c) in list_controller" :key="index_c">
                  <div class="p-field p-grid box-permission" v-if="item_c.list_modle_key.length == 0">
                    <div class="p-col-6 box-left permission-left">
                      <div class="box span-label">{{ item_c.name }}</div>
                    </div>
                    <div class="p-col-6 box-right permission-right">
                      <!-- cho 1 cấp -->
                      <div v-if="item_c.is_parent == 0" class="row custom-lable div-checkbox">
                        <div v-for="(roles_for, index_roles_for) in item_c.roles" :key="index_roles_for" class="d-flex col-12 align-items-center ml-3 mb-3 p-0">
                          <Checkbox :id="`checkbox-id-${roles_for.id}`" class="mr-2" v-model="checked[roles_for.id]" :binary="true"/>
                          <label :for="`checkbox-id-${roles_for.id}`" class="txt-right mb-0">{{roles_for.name}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div :class="{ content : true, active: currentTab == 4 }">
              <div class="position-relative">
                <div>
                  <div class="p-field p-grid box-permission">
                    <div class="p-col-6 box-left permission-left">
                      <div class="box span-label">Vai trò người dùng</div>
                    </div>
                    <div class="p-col-6 box-right permission-right">
                      <!-- cho 1 cấp -->
                      <div class="row custom-lable div-checkbox">
                        <div class="d-flex col-12 align-items-center ml-3 mb-3 p-0">
                          <Checkbox class="mr-2" v-model="check_giam_doc" :binary="true"/>
                          <label class="txt-right mb-0">Giám đốc</label>
                        </div>
                        <div class="d-flex col-12 align-items-center ml-3 mb-3 p-0">
                          <Checkbox class="mr-2" v-model="check_giam_sat_vien" :binary="true"/>
                          <label class="txt-right mb-0">Giám sát viên</label>
                        </div>
                        <div class="d-flex col-12 align-items-center ml-3 mb-3 p-0">
                          <Checkbox class="mr-2" v-model="check_nhan_vien" :binary="true"/>
                          <label class="txt-right mb-0">Nhân viên</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <span style="color:red;">(*)Lưu ý</span>: <span>Phân quyền này sẽ ảnh hưởng đến các module sau: </span>
                  <ul>
                    <li v-for="(item, index) in list_module_kh" :key="index">{{ item.label }}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="loading-controller" v-show="loading_controller">
              <div>
                <span class="fa fa-spinner fa-spin"></span>
                <span>Đang tải...</span>
              </div>
            </div>
        </div>
    <Toolbar class="fixed-bottom-toolbar">
      <template slot="right">
        <Button
          :label="$constants.TEXT_BUTTON.BACK"
          @click="backToList()"
          class="p-button-warning callback-btn"
        />
        <Button
          v-if="mode == 'edit'"
          :label="$constants.TEXT_BUTTON.EDIT"
          @click="saveData()"
          class="p-button-success main-style-button"
        />
        <Button
          v-else
          :label="$constants.TEXT_BUTTON.ADD"
          @click="saveData()"
          class="p-button-success main-style-button"
        />
      </template>
    </Toolbar>
  </div>
  </form>
</template>

<script>
import DropdownScrollable from '@/components/DropdownScrollable.vue';
import ApiRepository from "@/core/ApiRepository";
export default {
  components:{
    DropdownScrollable
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
    company_id: String
  },
  data() {
    return {
      hideTab : 0,
      hideTab1 : 0,
      hideTab2 : 0,
      hideTab3 : 0,
      hideTab4 : 0,
      check_giam_doc: false,
      check_giam_sat_vien: false,
      check_nhan_vien: false,
      name: '',
      validationErrors: {},
      formMode: this.mode,
      saving:false,
      list_controller: [],
      list_role: [],
      company: {},
      filters: {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      checked: [],
      loading_controller: false,
      currentTab : null,
      list_module_kh: [],
      edit_id: null,
    }
  },
  async mounted() {
    this.$commonFuction.is_loading(true);
    await this.getControllerList();
    await this.getListCompany();
    await this.getBaseModules();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.edit_id = this.model.id;
      this.company = {id: this.model.company_id};
      this.name = this.model.name;
      if (this?.company_id) {
        this.company = {id: this.company_id};
      }
      Promise.all(this.model.group_roles.map(m => {
        this.checked[m.role_id] = true;
      })).then(() => {
        this.$commonFuction.is_loading(false);
      })

      await this.getBaseGroupRoles();
    
    } else {
      this.$commonFuction.is_loading(false);
      if (this?.company_id) {
        this.company = {id: this.company_id};
      }
    }
    
  },
  watch: {
    async "company"(){
      await this.getControllerList();
      await this.getBaseModules();
    }

  },
  methods: {
    async emitEvent(keyword) {
      this.$delete(this.filters, 'name');
      if (keyword) {
        this.filters.name = keyword;
      }
      await this.getListCompany();
    },
    async changeOffset(value) {
      this.offset = value;
      // await this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.filters, limit: 20, offset: this.offset}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.items.push(...res.data.data.company);
          } else {
            this.items = res.data.data.company;
          }
          this.total = res.data.data.total;
          this.loading = false;
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },
    async getControllerList() {
      this.loading_controller = true;
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        console.log("this.companythis.companythis.company", this.company);
        await ApiRepository.post("/_api/group/controller", {company_id: this.company?.id}, {headers}).then((res) => {
          // this.list_controller = res.data.data;
          var tmp = res.data.data
          for (let i = 0; i < tmp.length; i++) {
            var key_texts = tmp[i].base_module_key ? tmp[i].base_module_key.split(',') : [];
            tmp[i].list_modle_key = key_texts;
          }
          // console.log("this.list_controllertmp", tmp);
          this.list_controller = tmp;
          this.loading_controller = false;
        }).catch((err) => {
            console.log(err);
            this.loading_controller = false;
        })
      }
    },
    backToList() {
      this.$emit('back');
    },
    async validateData() {
      this.validationErrors = {};

      let name_add = document.getElementById("name");
      console.log("name_add",name_add)
      if (this.name == undefined || this.name == null || this.name == ''){
        name_add.setCustomValidity("Tên nhóm quyền không được để trống!");
      }else {
        name_add.setCustomValidity("");
      }

      var checked = [];
      console.log(this.checked);
      var check_arr = Object.keys(this.checked);
      checked = check_arr.filter(f => this.checked[f]);

      let role_add = document.getElementById("role");
      if (checked.length < 1) {
        role_add.setCustomValidity("Vui lòng kích hoạt tối thiểu 1 nút tính năng để lưu nhóm quyền!");
      }else {
        role_add.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()){
        console.log('test=====================');
        inpObj.reportValidity();
        return true;
      }
    },
    async saveData() {
      console.log("ưqqqqqqqqqqqqq")
     /* if(this.saving == true){
        return;
      }
      this.saving = true;*/
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
      //  this.saving = false;
        this.$commonFuction.is_loading(false);
        return
      }
      var checked = [];
      console.log(this.checked);
      var check_arr = Object.keys(this.checked);
      checked = check_arr.filter(f => this.checked[f]);
      var params = {
        name: this.name,
        roles: checked,
        company_id: this.company?.id,
        check_giam_doc: this.check_giam_doc,
        check_giam_sat_vien: this.check_giam_sat_vien,
        check_nhan_vien: this.check_nhan_vien,
      }
      console.log('saveData', params)
      // this.$commonFuction.is_loading(false);
      this.$emit('save', params);
    },
    showContent(index){
        this.currentTab = index
    },
    async getBaseModules() {
      var list_module_kh = [];
      var hideTab = 0; //ẩn tab QL nhà thầu, QL rủi ro
      var currentTab = null
      var hideTab1 = 0; //ẩn tab chức năng khác
      var hideTab2 = 0; //ẩn tab chức năng khác
      var hideTab4 = 0; //ẩn tab chức năng khác
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var {data} = await ApiRepository.post("/_api/group/base_modules", {company_id: this.company?.id}, {headers});
        var value = data.data;
        // console.log("valuevaluevalue", value);
        if(value && value.length > 0){
          for (let i = 0; i < value.length; i++) {
            if(value[i]._key == 'system'){
              hideTab = 1;
            }else if(value[i]._key == 'contractors_management'){
              hideTab1 = 1;
            }else if(value[i]._key == 'risk_management'){
              hideTab2 = 1;
            }else if(value[i].is_hse == false){
              hideTab4 = 1;
              list_module_kh.push(value[i]);
            }
          }
        }
      }
      if(hideTab == 1){
        currentTab = 0;
      }else if(hideTab1 == 1){
        currentTab = 1;
      }else if(hideTab2 == 1){
        currentTab = 2;
      }else if(hideTab4 == 1){
        currentTab = 3;
      }
      this.currentTab = currentTab;
      this.hideTab = hideTab;
      this.hideTab1 = hideTab1;
      this.hideTab2 = hideTab2;
      this.hideTab4 = hideTab4;
      this.list_module_kh = list_module_kh;
    },
    async getBaseGroupRoles() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var {data} = await ApiRepository.post("/_api/group/group_course_roles", {group_id: this.edit_id}, {headers});
        var value = data.data;
        console.log("valuevaluevalue", value);
        var check_giam_doc = false;
        var check_giam_sat_vien = false;
        var check_nhan_vien = false;
        if(value && value.length > 0){
          for (let i = 0; i < value.length; i++) {
            if(value[i].role_text == 'manager'){
              check_giam_doc = true;
            }else if(value[i].role_text == 'supervisor'){
              check_giam_sat_vien = true;
            }else if(value[i].role_text == 'employee'){
              check_nhan_vien = true;
            }
          }
        }
        this.check_giam_doc = check_giam_doc;
        this.check_giam_sat_vien = check_giam_sat_vien;
        this.check_nhan_vien = check_nhan_vien;
      }
    },
    
  }
}
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.permission-left {
    border: 1px solid #D0D4D9;
    border-radius: 5px 0 0 5px;
    padding: 20px !important;
}
.permission-right {
    padding: 20px !important;
    border: 1px solid #D0D4D9;
    border-radius: 0 5px 5px 0;
    border-left: none;
}
.box-permission {
  margin: 10px 0;
}
.loading-controller {
  width: 100%;
  height: 100%;
  background-color: #0000006e;
  position: absolute;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.loading-controller span{
  // content: "Đang tải...";
  margin: 0 5px;
  // position: absolute;
  // top: 0;
  // left: 0;
  // right: 0;
  // bottom: 0;
  // text-align: center;
  // align-self: center;
  color: #fff;
  font-size: 15pt;
  font-weight: bold;
}
.hide-tab {
    display: none;
}
.tab {
        display: flex;
        font-weight: 700;
        border-bottom: 1px solid #00000029;
    }
    .tab div {
        padding: 6px 8px;
        /* margin-right: 2px; */
        cursor: pointer;
    }
    .tab div.active {
        background-color: #fff;
        color: #0086C4;
        border-left: 1px solid #0086C4;
        border-right: 1px solid #0086C4;
        border-bottom: 3px solid #0086C4;
        border-top: 1px solid #0086C4;
    }
    .content {
        padding-top: 10px;
        display: none;
    }
    .content.active {
        display: block;
    }
</style>
